module.exports = __webpack_public_path__ + "media/newstyle/images/icon-quadrado-291d3c15587296180a20bff11cb92943.svg";